import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@material-ui/core";
import findClientCodeUseCase from "clients/services/findClientCodeUseCase";
import updateClientCodeUseCase from "clients/services/updateClientCodeUseCase";
import React, { Component } from "react";
import { connect } from "react-redux";
import TableClients from "../components/TableClients";
import { getClients } from "../services/actions";
import addClientUseCase from "../services/addClientUseCase";
import { columnsClients } from "../services/config";
import { saveClient } from "../api";
import deleteClientUseCase from "../services/deleteClientUseCase";
import { getClientsData } from "../services/reducers";
import updateClientUseCase from "../services/updateClientUseCase";
import CheckPaid from "tasks/components/CheckPaid";
import { makeZebraRowStyle } from 'common/services/zebraRowStyle';
import { Typography } from '@material-ui/core';

class ClientsListContainer extends Component {

    constructor() {
        super()
        this.tableRef = React.createRef()
        this.state = {
            saving: false,
            openSettings: false,
            codClient: '',
            tasksSelected: [],
            selectAll: false,
            loadingColumns: false
        }
    }

    handleTaskDelete = async (task) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task]

        for (let i = 0; i < tasks.length; i++) {
            await deleteClientUseCase(tasks[i])
        }

        this.setState({...this.state, tasksSelected: [] })
        return true
    }

    handleCheckedSelected = (task, flag) => {
        if (flag) {
            this.setState({...this.state, tasksSelected: [...this.state.tasksSelected, task ]})
            this.props.clients[task.id].selected = true
            return
        }

        const tasksSelected = this.state.tasksSelected.filter(taskSelect => taskSelect.id !== task.id)
        this.setState({...this.state, tasksSelected })
    }

    handleSelectAll = flag => {
        if (flag) {
            const tasksSelected = this.tableRef.current.dataManager.searchedData
            this.setState({...this.state, tasksSelected, selectAll: flag })
            return
        }

        this.setState({...this.state, tasksSelected: [], selectAll: flag })
    }

    componentDidMount() {
        const { clients, getClients } = this.props

        this.setState({ ...this.state, loadingColumns: true })

        if (clients.length === 0) {
            getClients()
        }

        const checkedSelected = (props) => {
            if (!props) {
                return
            }

            return (
                <CheckPaid props={props} 
                    field="selected" 
                    handleChangePaid={this.handleCheckedSelected} 
                    deselect={!this.state.tasksSelected.length}
                    select={this.state.tasksSelected.some(task => task.id === props.id)}
                />
            )
        }

        const checkAll = () => {
            return (
                <Checkbox checked={this.state.selectAll} onChange={e => this.handleSelectAll(e.target.checked) }/>
            )
        }

        const handleIvaToggle = async (client) => {
            const newIva = client.iva !== false ? false : true
            await saveClient({ id: client.id, iva: newIva })
        }

        this.columns = columnsClients(checkedSelected, checkAll, handleIvaToggle)

        this.setState({ ...this.state, loadingColumns: false })
    }

    render() {
        const { clients } = this.props

        const isMobile = window.matchMedia('(max-width:600px)').matches;

        const getRowStyle = makeZebraRowStyle({
            selectedIds: this.state.tasksSelected.map(t => t.id),
            getRowKey: row => row.id,
            selected: '#FDE0EA',
            even: '#cadcffff',
            odd: '#d5e4ffff',
            text: 'black'
        });

        const handleOpenSettings = async(flag) => {
            let state = {}
            if (!flag) {
                state = { ...this.state, openSettings: false }
            } else {
                const codClient = await findClientCodeUseCase()
                state = { ...this.state, openSettings: true, codClient }
            }

            this.setState(state)
        }

        const handleUpdateClientCode = async () => {
            await updateClientCodeUseCase(this.state.codClient)
            handleOpenSettings(false)
            window.location.reload()
        }

        const tasksSelected = this.state.tasksSelected;

        let comSelect = null

        if (tasksSelected.length > 0 && tasksSelected.length < 10) {
            comSelect = 
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS:</span> { this.state.tasksSelected.map(task => task.id).join(', ') }</span>
                </div>
        } else if (tasksSelected.length >= 10) {
            comSelect = 
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS SELECCIONADAS:</span> { this.state.tasksSelected.length }</span>
                </div>
        }

        return (
            <div style={{ padding: '20px 20px 20px 20px' }}>             
                { comSelect }
                {!this.state.loadingColumns &&<TableClients
                    columns={this.columns}
                    loading={false}
                    data={getClientsData(clients).sort((c1, c2) => c2.lastUpdated - c1.lastUpdated)}
                    onClientAdd={addClientUseCase}
                    onClientUpdate={updateClientUseCase}
                    onClientDelete={this.handleTaskDelete}
                    handleOpenSettings={handleOpenSettings}
                    tableRefProp={this.tableRef}
                    getRowStyle={getRowStyle}
                    extraActions={[]}
                />}
                <Dialog open={this.state.openSettings}>
                    <DialogTitle>Ajustes de clientes</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Estos son los ajustes que puedes hacer sobre la pantalla de clientes.
                        </DialogContentText>
                        <TextField
                            id='codClientInput'
                            label='Código cliente'
                            value={this.state.codClient}
                            type="number"
                            fullWidth
                            onChange={event => this.setState({ ...this.state, codClient: event.target.value })}
                        />
                        <DialogActions>
                            <Button onClick={() => handleOpenSettings(false)}>
                                Cancelar
                            </Button>
                            <Button onClick={handleUpdateClientCode} color='primary'>
                                Aceptar
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    getClients: payload => dispatch(getClients(payload))
})

const mapStateToProps = state => ({
    clients: state.clients.data
})

export default connect(mapStateToProps, mapDispatchToProps)(ClientsListContainer)